import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './css/myStyle.css';
import DataHandler from "./dataHandler";
import location from "./img/location.png";
import person from "./img/person.png";
import organization from "./img/organization.png";
import property from "./img/property.png";

global.getCookie = function (cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
    }
    return ''
};

global.setCookie = function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toGMTString();
    const Domain = 'domain=.newsminer.net';
    // const Domain = 'domain=localhost';
    document.cookie = cname + '=' + cvalue + ';' + expires + ';' + Domain
};

global.nodeConf = {
    large: {
        nodeRadio: 30,
        iconRadio: 20,
        fontSize: 14,
        borderSize: 2,
        indexRadio: 8,
        indexNumSize: 8,
        indexAngle: 30.6
    },
    middle: {
        nodeRadio: 25,
        iconRadio: 15,
        fontSize: 12,
        borderSize: 2,
        indexRadio: 8,
        indexNumSize: 8,
        indexAngle: 36.67
    },
    small: {
        nodeRadio: 20,
        iconRadio: 12,
        fontSize: 10,
        borderSize: 2,
        indexRadio: 8,
        indexNumSize: 8,
        indexAngle: 45.84
    },
    tiny: {
        nodeRadio: 15,
        iconRadio: 10,
        fontSize: 10,
        borderSize: 2,
        indexRadio: 8,
        indexNumSize: 10,
        indexAngle: 45.84
    },
    icon: {
        location: location,
        person: person,
        organization: organization,
        xloreRelation: property
    },
    iconFill: {
        location: '#687A8C',
        person: '#687A8C',
        organization: '#687A8C',
        xloreRelation: '#019c9e'
    },
    iconBorder: {
        location: '#8345a4',
        person: '#99ce7e',
        organization: '#e6b34e',
        xloreRelation: '#019c9e'
    }
};


export default class Home extends React.Component {

    componentDidMount() {
        let date = global.getCookie('date');
        const newDate = new Date().toLocaleDateString();
        if (date !== newDate) {
            global.setCookie('date', newDate, 1);
        }

        const getPageUrl = 'https://api2.newsminer.net/svc/portraitDaily/getPage?date=' + date;
        fetch(getPageUrl, {
            method: 'get',
            referrer: document.location.toString().split("?")[0],
        }).catch(e => console.log('错误:', e));  ///请求出错
    }

    render() {
        return <DataHandler/>
    }

}

ReactDOM.render(<Home/>, document.getElementById('root'));

serviceWorker.unregister();
